import { render, staticRenderFns } from "./UtilityLicenseePayment.vue?vue&type=template&id=21db5aaf"
import script from "./UtilityLicenseePayment.vue?vue&type=script&lang=js"
export * from "./UtilityLicenseePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports